import styled from '@emotion/styled';
import { SearchFooter } from '@atlassian/search-dialog';
import Button from '@atlaskit/button';
import { N20, N900 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const FeedbackLinkWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: `var(--ds-background-neutral, ${N20})`,
  padding: `${"var(--ds-space-050, 4px)"} 0`
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const FeedbackLink = styled(Button)`
  && {
    text-decoration: underline;
    &:hover {
      color: ${`var(--ds-link-pressed, ${N900})`} !important;
    }
  }
`;
const searchFooterWrapperHeight = "var(--ds-space-1000, 80px)";

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SearchFooterWrapper = styled(SearchFooter)({
  display: 'flex',
  flexDirection: 'column',
  height: searchFooterWrapperHeight
});